import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';

import { ReactComponent as MenuIcon } from '@pharmaplan/common/assets/icons/menuIcon.svg';

import { IMenuActions } from '../../common/CustomAvatarSection/CustomAvatarSection';
import CustomMenuList from '../../common/CustomMenuList/CustomMenuList';
import { getDayMonthDateYear } from '../../Reports/helpers';

import CopyShiftUrlButton from './CopyShiftUrlButton';
import styles from './styles';
import strings from '../../../localization';
import withSkeleton from '../../common/WithSkeleton';
import { SkeletonVariants } from '../../../helpers/Constants';

interface IAvailableWorkshiftRightSection {
  menuActions: Array<IMenuActions> | null;
  postedDate: string;
  successAction:string;
  workshiftId: string;
  isAutoSyncRecord: boolean;
}

const AvailableWorkshiftRightSection: FC<IAvailableWorkshiftRightSection> = ({
  menuActions,
  postedDate,
  successAction,
  workshiftId,
  isAutoSyncRecord,
}) => {
  const date = getDayMonthDateYear(postedDate);
  const SkeletonTypography = withSkeleton({ successAction, variant: SkeletonVariants.text })(Typography);

  return (
    <Box sx={styles.rightSectionContainer}>
      <Box sx={styles.menuContainer}>
        <CopyShiftUrlButton
          workshiftId={workshiftId}
          isAutoSyncRecord={isAutoSyncRecord}
        />
        <CustomMenuList
          margin={10}
          disableFixedDropdown
          customMenuTextStyle={styles.menuText}
          customIconButtonStyle={styles.button}
          items={menuActions ?? []}
        >
          <MenuIcon height={24} width={24} />
        </CustomMenuList>
      </Box>
      <Box sx={styles.postedOnContainer}>
        <SkeletonTypography sx={styles.postedOnText}>
          {`${strings.postedOn} ${date}`}
        </SkeletonTypography>
      </Box>
    </Box>
  );
};
export default AvailableWorkshiftRightSection;
